function resize() {

    console.log('lifecycle :', 'resize loading scene');
}

export {resize};
